export const DATA_HOOKS = {
  FORM: 'form',
  REJECTION_REASON_INPUT: 'rejectionReasonInput',
};
